<template>
  <v-container fluid>
    <v-card class="mx-auto mb-4">
      <v-list three-line>
        <template>
          <v-subheader>{{ company.name }}</v-subheader>

          <v-list-item :key="company.title">
            <img :src="company.avatar" />

            <v-list-item-content class="pl-3">
              <v-list-item-title
                ><h5>{{ company.name }}</h5></v-list-item-title
              >
              <v-list-item-subtitle
                >Địa chỉ: {{ company.address }}</v-list-item-subtitle
              >
              <v-list-item-subtitle
                >SĐT: {{ company.phone }}</v-list-item-subtitle
              >
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>
    </v-card>
    <v-row >
      <v-col sm="12" lg="6" md="6" xs="12"><dia-diem></dia-diem></v-col>
      <v-col sm="12" lg="6" md="6" xs="12"><Ca /></v-col>
    </v-row>
  </v-container>
</template>

<script>
import DiaDiem from "./components/diadiem/diadiem";
import Ca from "./components/calamviec/ca"
import Logo from '../../../assets/images/logo-phuthanh-led.png'
export default {
  components: { DiaDiem, Ca },
  data: () => ({
    company: {
      name: "Công ty cổ phần Phú Thành",
      avatar: Logo,
      address: "Lô S5-10, cụm công nghiệp làng nghề xã Tân Triều, Huyện Thanh Trì, Hà Nội",
      phone: "(028) 3 886 9889",
    },
  }),
};
</script>

<style>
</style>